import { RootState } from '../store';

export const selectContexts = (state: RootState) => state.context.contexts;
export const selectStats = (state: RootState) => state.context.stats;

export default {
  selectContexts,
  selectStats,
};
